import { render, staticRenderFns } from "./DropdownLogin.vue?vue&type=template&id=8a88e96c&scoped=true&"
import script from "./DropdownLogin.vue?vue&type=script&lang=js&"
export * from "./DropdownLogin.vue?vue&type=script&lang=js&"
import style0 from "./DropdownLogin.vue?vue&type=style&index=0&id=8a88e96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a88e96c",
  null
  
)

export default component.exports